module.exports = __webpack_public_path__ + "img/no2_es.40ceaabb.jpg";